import { Box, Grid, Typography } from "@mui/material";
import CustomField from "../../../../../../components/CustomFormsComponents/CustomField";
import ButtonActions from "../../../../../../components/ButtonActions";
import { useState } from "react";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import { ResponsibleCard } from "../ResponsibleCard";
import Button from "../../../../../../components/button/Button";
import { getDate } from "../../../../../../utils/common";
import BackdropComponent from "../../../../../../components/Backdrop/BackdropComponent";
import { TEST_IDS } from "../../testIds";

const ResponsibleForm = ({
    selectedCarcinogenicReportId,
    selectedRadiologicalEquipment,
    isEditing,
    handleCloseDrawer,
    responsibleForm,
    handleAddNewResponsible,
    localResponsibles,
    handleSubmit,
    handleDeleteLocalResponsibleClick,
    handleDeleteSaveResponsibleClick,
    isDeletingEquipmentResponsible,
    selectedEquipmentSubstance,
    handleCancelClick,
    onlyVisual
}: any) => {
    const { responsiblesFieldsConfig, formData, handleChange, errors, translate, validateForm, resetForm } = responsibleForm
    const [showResponsibleForm, setShowResponsibleForm] = useState<boolean>(false);
    const carcinogenicReportData = useAppSelector(
        (state) => state.carcinogenicReport.carcinogenicReport
    );

    const handleNewResponsibleClick = () => {
        if (!validateForm(formData, responsiblesFieldsConfig))return 
        handleAddNewResponsible();
        resetForm();
        setShowResponsibleForm(false);
    }

    return (
        <Box
            display="flex"
            flexDirection={'column'}
            justifyContent="space-between"
            sx={{ flexDirection: 'column', height: '100%', minHeight: '100%' }}
        >
            <Grid mt={2} container rowSpacing={0.01}>
                <Grid maxHeight={'350px'} overflow={'auto'} xs={12}>
                    {(localResponsibles?.length > 0 ||
                        carcinogenicReportData?.responsables?.length > 0) && (
                        <Grid mt={2} xs={12}>
                            {localResponsibles.map((localResponsible: any, index: number) => (
                                <ResponsibleCard
                                    name={localResponsible?.nombre}
                                    surname={localResponsible?.apellido}
                                    cuit={localResponsible?.cuit}
                                    permission={localResponsible?.permiso}
                                    licenseNumber={localResponsible?.matricula}
                                    expeditionDate={localResponsible?.fechaExpedicion}
                                    expirationDate={localResponsible?.fechaVencimiento}
                                    type={localResponsible?.idTipoResponsable}
                                    otherData={''}
                                    handleDeleteClick={() =>
                                        handleDeleteLocalResponsibleClick(index)
                                    }
                                    translate={translate}
                                    onlyVisual={onlyVisual}
                                />
                            ))}
                        </Grid>
                    )}

                    {isEditing &&
                        selectedRadiologicalEquipment?.responsables?.map((responsible: any) => (
                            <Grid mt={2} xs={12}>
                                <ResponsibleCard
                                    name={responsible?.nombre}
                                    surname={responsible?.apellido}
                                    cuit={responsible?.cuit}
                                    permission={responsible?.permiso}
                                    licenseNumber={responsible?.matricula}
                                    expeditionDate={getDate(responsible?.fechaExpedicion)}
                                    expirationDate={getDate(responsible?.fechaVencimiento)}
                                    type={responsible?.idTipoResponsable}
                                    otherData={''}
                                    handleDeleteClick={() =>
                                        handleDeleteSaveResponsibleClick(responsible?.id)
                                    }
                                    translate={translate}
                                    onlyVisual={onlyVisual}
                                />
                            </Grid>
                        ))}
                </Grid>
                <Grid display={'flex'} container width={'100%'} justifyContent={'flex-end'} mt={1}>
                    {!onlyVisual && (
                        <Button
                            disabled={showResponsibleForm}
                            type="contained"
                            onClick={() => setShowResponsibleForm(true)}
                            loading={false}
                            testID={TEST_IDS.newRadiologicalEquipment.buttons.newResponisble}
                        >
                            {translate('radiologicalEquipmentForm.buttons.newResponsible')}
                        </Button>
                    )}
                </Grid>

                {showResponsibleForm && (
                    <Box bgcolor={'#F8F8F8'} borderRadius={'8px'} p={'24px 16px'} mt={2}>
                        <Grid container spacing={2} rowSpacing={0.01}>
                            <Grid xs={12} pl={2}>
                                <Typography variant="subtitle1">
                                    {translate('radiologicalEquipmentForm.titles.responsibleData')}
                                </Typography>
                            </Grid>
                            {responsiblesFieldsConfig.map((field: any, index: any) => (
                                <Grid
                                    item
                                    xs={field?.gridSpace?.xs}
                                    sm={field?.gridSpace?.sm}
                                    md={field?.gridSpace?.md}
                                    lg={field?.gridSpace?.lg}
                                    key={index}
                                >
                                    <CustomField
                                        config={field}
                                        value={formData[field.name as keyof any]}
                                        onChange={handleChange}
                                        onlyVisual={onlyVisual}
                                        error={errors[field.name as string]?.hasError}
                                        helperText={
                                            errors[field.name as string]?.errorMessage ||
                                            field.helperText
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            sx={{ marginTop: '1rem' }}
                        >
                            <Box
                                sx={{
                                    '& > :not(style)': { m: 1 },
                                    display: 'flex'
                                }}
                            >
                                <ButtonActions
                                    renderBackAction
                                    returnText={translate(
                                        'radiologicalEquipmentForm.buttons.cancel'
                                    )}
                                    confirmText={translate(
                                        'radiologicalEquipmentForm.buttons.addResponsible'
                                    )}
                                    loading={false}
                                    disabled={false}
                                    handleClose={() => setShowResponsibleForm(false)}
                                    onClick={handleNewResponsibleClick}
                                    borderRadius="4px"
                                    size="small"
                                />
                            </Box>
                        </Grid>
                    </Box>
                )}
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ marginTop: '1rem' }}
            >
                <Box
                    sx={{
                        '& > :not(style)': { m: 0 },
                        display: 'flex'
                    }}
                >
                    {!onlyVisual && (
                        <ButtonActions
                            handleClose={handleCancelClick}
                            renderBackAction
                            returnText={translate('radiologicalEquipmentForm.buttons.cancel')}
                            confirmText={translate('radiologicalEquipmentForm.buttons.save')}
                            loading={false}
                            disabled={false}
                            onClick={handleSubmit}
                            borderRadius="4px"
                            size="small"
                        />
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default ResponsibleForm